import { Tag } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { FecThirdPartyRole } from '../../../../../../enums/fecThirdPartyRole'
import { FecThirdPartyStatus } from '../../../../../../enums/fecThirdPartyStatus'

const ROLE_TRANSLATION_KEYS: Record<FecThirdPartyRole, string> = {
  [FecThirdPartyRole.Client]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.type.client',
  [FecThirdPartyRole.Supplier]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.type.supplier',
}

const STATUS_TRANSLATION_KEYS: Record<FecThirdPartyStatus, Record<FecThirdPartyRole, string>> = {
  [FecThirdPartyStatus.Existing]: {
    [FecThirdPartyRole.Client]:
      'settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.status.existing_client',
    [FecThirdPartyRole.Supplier]:
      'settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.status.existing_supplier',
  },
  [FecThirdPartyStatus.New]: {
    [FecThirdPartyRole.Client]:
      'settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.status.new_client',
    [FecThirdPartyRole.Supplier]:
      'settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.status.new_supplier',
  },
}

interface ThirdPartyTypeTagProps {
  role: FecThirdPartyRole
  /** Set when the organisation has saved third-party contacts: the tag then shows the status instead of the role. */
  status?: FecThirdPartyStatus
}

export const ThirdPartyTypeTag = ({ role, status }: ThirdPartyTypeTagProps): ReactElement => {
  const { t } = useTranslation()

  // A role the app doesn't know yet shows as the raw value instead of an empty tag.
  if (!status) {
    const roleKey = ROLE_TRANSLATION_KEYS[role]

    return <Tag color="neutral" label={roleKey ? t(roleKey) : String(role)} size="small" type="subtle" />
  }

  const statusKey = STATUS_TRANSLATION_KEYS[status][role]

  return (
    <Tag
      color={status === FecThirdPartyStatus.Existing ? 'neutral' : 'blue'}
      label={statusKey ? t(statusKey) : String(role)}
      size="small"
      type="subtle"
    />
  )
}
